/** Visible KLIPY attribution for provider-hosted GIFs. */

/** Props for the reusable KLIPY attribution mark. */
export interface KlipyAttributionProps {
  className?: string;
}

/** A compact provider mark shown wherever KLIPY content appears. */
export function KlipyAttribution({ className = '' }: KlipyAttributionProps) {
  return (
    <a
      href="https://klipy.com/"
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center rounded-md bg-black/75 px-2 py-1 text-[10px] font-semibold leading-none text-white backdrop-blur-sm hover:underline ${className}`}
    >
      Powered by KLIPY
    </a>
  );
}
